(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoniq-how-it-works"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yoniq-video-rail')) {
    customElements.define('yoniq-video-rail',class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort(); this.abort=new AbortController();
        const {signal}=this.abort, rail=this.querySelector('.yoniq-how__rail'), cards=[...this.querySelectorAll('.yoniq-how__card')];
        this.dialog=this.querySelector('dialog'); this.player=this.querySelector('.yoniq-how__player');
        if(!rail||!this.dialog)return;
        const nav=this.querySelector('.yoniq-how__navigation'), previous=nav.querySelector('[data-direction="-1"]'), next=nav.querySelector('[data-direction="1"]');
        const behavior=()=>matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth';
        const position=card=>card.getBoundingClientRect().left-rail.getBoundingClientRect().left+rail.scrollLeft-parseFloat(getComputedStyle(rail).paddingLeft);
        const update=()=>{
          const max=rail.scrollWidth-rail.clientWidth, box=rail.getBoundingClientRect();
          nav.hidden=max<2; previous.disabled=rail.scrollLeft<=2; next.disabled=rail.scrollLeft>=max-2;
          const visible=cards.map((card,index)=>({box:card.getBoundingClientRect(),index:index+1})).filter(item=>Math.min(item.box.right,box.right)-Math.max(item.box.left,box.left)>item.box.width*.5);
          if(visible.length){const first=visible[0].index,last=visible[visible.length-1].index;nav.querySelector('.yoniq-how__count').textContent=(first===last?first:first+'–'+last)+' / '+cards.length;}
        };
        const go=direction=>{
          const offsets=cards.map(position), current=rail.scrollLeft;
          const target=direction>0?offsets.find(x=>x>current+4):offsets.findLast(x=>x<current-4);
          rail.scrollTo({left:target??(direction>0?rail.scrollWidth:0),behavior:behavior()});
        };
        nav.addEventListener('click',event=>{const button=event.target.closest('[data-direction]');if(button)go(Number(button.dataset.direction));},{signal});
        let drag=null, suppressUntil=0;
        rail.addEventListener('pointerdown',event=>{
          if(event.pointerType!=='mouse'||event.button!==0)return;
          suppressUntil=0; drag={id:event.pointerId,x:event.clientX,left:rail.scrollLeft,moved:false};
        },{signal});
        rail.addEventListener('pointermove',event=>{
          if(!drag||event.pointerId!==drag.id)return;
          const distance=event.clientX-drag.x;
          if(!drag.moved&&Math.abs(distance)<8)return;
          if(!drag.moved){drag.moved=true;rail.classList.add('is-dragging');rail.setPointerCapture(event.pointerId);}
          rail.scrollLeft=drag.left-distance; event.preventDefault();
        },{signal});
        const end=()=>{if(drag?.moved)suppressUntil=performance.now()+350;drag=null;rail.classList.remove('is-dragging');};
        rail.addEventListener('pointerup',end,{signal});rail.addEventListener('pointercancel',end,{signal});rail.addEventListener('lostpointercapture',end,{signal});
        rail.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)drag=null;},{signal});
        rail.addEventListener('dragstart',event=>event.preventDefault(),{signal});
        rail.addEventListener('click',event=>{
          if(event.detail&&performance.now()<suppressUntil){event.preventDefault();event.stopPropagation();return;}
          const button=event.target.closest('.yoniq-how__preview');
          if(button&&!button.disabled)this.openPlayer(button);
        },{signal});
        rail.addEventListener('keydown',event=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
          event.preventDefault();
          if(event.key==='Home'||event.key==='End')rail.scrollTo({left:event.key==='Home'?0:rail.scrollWidth,behavior:behavior()});
          else go(event.key==='ArrowRight'?1:-1);
        },{signal});
        rail.addEventListener('scroll',update,{passive:true,signal});
        this.resizeObserver?.disconnect();this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(rail);update();
        this.querySelector('.yoniq-how__close').addEventListener('click',()=>this.dialog.close(),{signal});
        this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const box=this.dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)this.dialog.close();},{signal});
        this.dialog.addEventListener('close',()=>this.clearPlayer(),{signal});
        document.addEventListener('visibilitychange',()=>{if(document.hidden)this.player.querySelector('video')?.pause();},{signal});
        document.addEventListener('shopify:block:select',event=>{
          if(!this.contains(event.target))return;
          const card=event.target.closest('.yoniq-how__card');
          if(card)rail.scrollTo({left:position(card),behavior:'instant'});
        },{signal});
      }
      openPlayer(button) {
        const card=button.closest('.yoniq-how__card'), template=card.querySelector('template');
        if(!template)return;
        document.querySelectorAll('yoniq-video-rail dialog[open]').forEach(dialog=>dialog.close());
        this.trigger=button;this.player.replaceChildren(template.content.cloneNode(true));
        this.querySelector('.yoniq-how__dialog-bar span').textContent=card.getAttribute('aria-label');
        this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
        this.dialog.showModal();
        const video=this.player.querySelector('video');if(video)video.play().catch(()=>{});
      }
      clearPlayer() {
        this.player?.querySelectorAll('video').forEach(video=>video.pause());this.player?.replaceChildren();
        if(this.previousOverflow!==undefined){document.documentElement.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
        if(this.trigger?.isConnected)this.trigger.focus({preventScroll:true});this.trigger=null;
      }
      disconnectedCallback(){this.clearPlayer();this.dialog?.close();this.abort?.abort();this.resizeObserver?.disconnect();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoniq-pros"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yoniq-pros')) {
  customElements.define('yoniq-pros', class extends HTMLElement {
    static covers = new Map();

    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.xPlayers = new Map();
      const options = {signal:this.controller.signal};
      this.track = this.querySelector('.ypr__track');
      this.allCards = [...this.querySelectorAll('.ypr__card')];
      this.cards = this.allCards;
      this.mobile = matchMedia('(max-width:749px)');
      this.pages = this.querySelector('.ypr__pages');
      this.resize = new ResizeObserver(()=>{const width=this.track.clientWidth;if(width!==this.trackWidth){this.trackWidth=width;this.buildPages();}});
      this.cardResize = new ResizeObserver(()=>this.syncHeight());
      this.allCards.forEach(card=>this.cardResize.observe(card));
      this.resize.observe(this.track);
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.raf);this.raf=requestAnimationFrame(()=>this.updatePages());},options);
      this.track.addEventListener('keydown',event=>{
        if(event.target!==this.track || !['ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();this.go(Math.max(0,Math.min(this.pageStarts.length-1,this.current+(event.key==='ArrowRight'?1:-1))));
      },options);
      this.querySelectorAll('.ypr__poster:not(:disabled)').forEach(button=>button.addEventListener('click',()=>this.play(button.closest('.ypr__media')),options));
      this.querySelectorAll('.ypr__stop').forEach(button=>button.addEventListener('click',()=>this.stop(),options));
      document.addEventListener('shopify:block:select',event=>{const index=this.cards.findIndex(card=>card.dataset.blockId===event.detail.blockId);if(index>=0)this.go(Math.floor(index/this.perPage));},options);
      window.addEventListener('message',event=>this.resizeSocialEmbed(event),options);
      this.mobile.addEventListener('change',()=>{this.configureMedia();this.buildPages();this.go(0);},options);
      this.configureMedia();this.buildPages();
    }

    configureMedia(){
      this.stop();this.mediaEpoch=(this.mediaEpoch||0)+1;this.coverObserver?.disconnect();
      this.xPlayers.forEach(record=>record.resolve(null));this.xPlayers.clear();
      this.querySelectorAll('.ypr__media').forEach(media=>{
        const target=media.querySelector('.ypr__player');target.replaceChildren();target.hidden=true;
        media.classList.remove('ypr__media--social');media.style.removeProperty('--ypr-embed-height');
        media.querySelector('.ypr__poster').hidden=false;media.querySelector('.ypr__stop').hidden=true;
        const uploaded=this.mobile.matches&&!!media.querySelector('template');
        media.dataset.mobileUpload=String(uploaded);
        if(uploaded)media.style.setProperty('--ypr-mobile-ratio',media.dataset.uploadRatio||'9 / 16');
        const data=this.parse(media.dataset.url||'');
        if(uploaded||media.dataset.source==='upload'||media.dataset.source==='external'||media.dataset.nativeSocial==='false'||!data)return;
        if(this.mobile.matches&&data.x)return;
        if(data.provider==='instagram'||data.x)this.mountSocial(media,data);
      });
      this.loadCovers();
    }
    syncHeight(){
      if(!this.track)return;
      if(!this.mobile.matches){this.track.style.removeProperty('height');return;}
      const card=this.cards?.[this.pageStarts?.[this.current||0]];
      if(card){const height=Math.ceil(card.getBoundingClientRect().height)+3;if(this.track.style.height!==height+'px')this.track.style.height=height+'px';}
    }
    mountSocial(media,data){
      const frame=document.createElement('iframe'),target=media.querySelector('.ypr__player');
      frame.title=media.querySelector('.ypr__poster').getAttribute('aria-label');
      frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;
      frame.referrerPolicy='strict-origin-when-cross-origin';frame.loading='lazy';frame.scrolling='no';
      const lang=document.documentElement.lang.startsWith('zh')?'zh-cn':document.documentElement.lang.split('-')[0]||'en';
      frame.src=data.x?'https://platform.twitter.com/embed/Tweet.html?id='+data.x+'&dnt=true&theme=light&lang='+encodeURIComponent(lang):data.frame;
      media.dataset.provider=data.provider;media.classList.add('ypr__media--social');
      target.replaceChildren(frame);target.hidden=false;media.querySelector('.ypr__poster').hidden=true;
    }
    resizeSocialEmbed(event){
      if(!['https://www.instagram.com','https://platform.twitter.com'].includes(event.origin))return;
      let message=event.data;
      if(typeof message==='string'){try{message=JSON.parse(message);}catch{return;}}
      let height;
      if(event.origin==='https://www.instagram.com'&&message?.type==='MEASURE')height=message.details?.height;
      const tweet=message?.['twttr.embed'];
      if(event.origin==='https://platform.twitter.com'&&tweet?.method==='twttr.private.resize')height=tweet.params?.[0]?.height;
      if(typeof height!=='number'||!Number.isFinite(height)||height<100||height>6000)return;
      const frame=[...this.querySelectorAll('.ypr__media--social iframe')].find(frame=>frame.contentWindow===event.source);
      if(!frame)return;
      frame.closest('.ypr__media').style.setProperty('--ypr-embed-height',Math.ceil(height+2)+'px');
    }
    disconnectedCallback(){
      this.stop();this.controller?.abort();this.controller=null;this.resize?.disconnect();this.cardResize?.disconnect();this.coverObserver?.disconnect();cancelAnimationFrame(this.raf);
      this.xPlayers?.forEach(record=>record.resolve(null));this.xPlayers?.clear();this.querySelectorAll('.ypr__player').forEach(player=>player.replaceChildren());
      this.querySelectorAll('.ypr__cover-video').forEach(video=>{video.pause();video.removeAttribute('src');video.load();video.remove();});
    }
    buildPages(){
      this.cards=this.allCards.filter(card=>getComputedStyle(card).display!=='none');
      this.perPage=matchMedia('(max-width:749px)').matches?1:matchMedia('(max-width:989px)').matches?2:3;
      this.pageStarts=[];for(let i=0;i<this.cards.length;i+=this.perPage)this.pageStarts.push(i);
      this.pages.replaceChildren();this.pages.hidden=this.pageStarts.length<2;
      this.pageStarts.forEach((_,index)=>{
        const b=document.createElement('button');b.type='button';b.className='ypr__page';b.setAttribute('aria-label',this.dataset.pageLabel.replace('[number]',String(index+1)));
        b.append(this.querySelector('.ypr__pager-template').content.cloneNode(true));b.addEventListener('click',()=>this.go(index));this.pages.append(b);
      });this.updatePages();
    }
    go(index){this.stop();const card=this.cards[this.pageStarts[index]];if(!card)return;const trackRect=this.track.getBoundingClientRect();const cardRect=card.getBoundingClientRect();if(this.mobile.matches&&trackRect.top<0&&trackRect.top+cardRect.height<160){const headingTop=this.querySelector('.ypr__heading').getBoundingClientRect().top;window.scrollBy({top:headingTop-96,behavior:'instant'});}const offset=cardRect.left-trackRect.left+this.track.scrollLeft-(this.perPage===1?(trackRect.width-cardRect.width)/2:parseFloat(getComputedStyle(this.track).paddingLeft));this.track.scrollTo({left:offset,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
    updatePages(){if(!this.cards.length)return;const step=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);const next=Math.min(this.pageStarts.length-1,Math.round(this.track.scrollLeft/(step*this.perPage)));if(this.current!==undefined&&this.current!==next)this.stop();this.current=next;[...this.pages.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===next)));this.syncHeight();}

    parse(raw){try{
      const url=new URL(raw.trim());if(url.protocol!=='https:')return null;
      const host=url.hostname.replace(/^www\./,'');let id;
      if(host==='youtu.be')id=url.pathname.split('/')[1];
      if(['youtube.com','m.youtube.com','youtube-nocookie.com'].includes(host))id=url.searchParams.get('v')||url.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/)?.[1];
      if(id&&/^[\w-]{11}$/.test(id))return {url:url.href,provider:'youtube',frame:'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0',cover:'https://i.ytimg.com/vi/'+id+'/hqdefault.jpg'};
      if(['vimeo.com','player.vimeo.com'].includes(host)){
        const m=url.pathname.match(/(?:\/video)?\/(\d+)(?:\/([\w]+))?/);
        if(m)return {url:url.href,provider:'vimeo',frame:'https://player.vimeo.com/video/'+m[1]+'?autoplay=1'+((url.searchParams.get('h')||m[2])?'&h='+encodeURIComponent(url.searchParams.get('h')||m[2]):''),oembed:'https://vimeo.com/api/oembed.json?url='+encodeURIComponent(url.href)};
      }
      if(['tiktok.com','m.tiktok.com','vm.tiktok.com','vt.tiktok.com'].includes(host)){
        id=url.pathname.match(/\/video\/(\d+)/)?.[1];
        return {url:url.href,provider:'tiktok',frame:id?'https://www.tiktok.com/player/v1/'+id+'?autoplay=1':null,social:!!id,external:!id,oembed:'https://www.tiktok.com/oembed?url='+encodeURIComponent(url.href)};
      }
      if(host==='instagram.com'){const m=url.pathname.match(/^\/(p|reel|tv)\/([\w-]+)/);if(m)return {url:url.href,provider:'instagram',frame:'https://www.instagram.com/'+m[1]+'/'+m[2]+'/embed/',social:true};}
      if(['x.com','twitter.com','mobile.twitter.com','mobile.x.com'].includes(host)){
        id=url.pathname.match(/\/status\/(\d+)(?:\/|$)/)?.[1];
        if(id)return {url:url.href,provider:'x',x:id,mediaIndex:Math.max(0,Number(url.pathname.match(/\/video\/(\d+)/)?.[1]||1)-1),social:true};
      }
      if(['facebook.com','m.facebook.com','fb.watch'].includes(host))return {url:url.href,provider:'facebook',frame:'https://www.facebook.com/plugins/video.php?href='+encodeURIComponent(url.href)+'&show_text=false',social:true};
      if(/\.(mp4|webm|mov)$/i.test(url.pathname))return {url:url.href,native:true};
      return {url:url.href,external:true};
    }catch{return null;}}

    safeMediaURL(raw,host){try{const url=new URL(raw);return url.protocol==='https:'&&(!host||url.hostname===host)?url.href:null;}catch{return null;}}
    xMedia(post,index){
      const item=post?.media?.videos?.[index]||post?.media?.all?.[index];
      const formats=(item?.formats||item?.variants||[]).filter(f=>f.container==='mp4'||f.content_type==='video/mp4').filter(f=>this.safeMediaURL(f.url,'video.twimg.com')).sort((a,b)=>(a.bitrate||0)-(b.bitrate||0));
      const preferred=formats.filter(f=>(f.bitrate||0)<=3000000);
      return {cover:this.safeMediaURL(item?.thumbnail_url),video:this.safeMediaURL((preferred.at(-1)||formats.at(-1))?.url||item?.url,'video.twimg.com')};
    }
    async coverFor(data){return (await this.mediaFor(data))?.cover||null;}
    async mediaFor(data){
      if(data.cover)return {cover:data.cover};
      if(!data.x&&!data.oembed)return null;
      const key=data.x?'x:'+data.x+':'+data.mediaIndex:data.oembed;
      const cached=this.constructor.covers.get(key);
      if(cached&&Date.now()-cached.time<600000)return cached.promise;
      const promise=(async()=>{
        const endpoint=data.x?'https://api.fxtwitter.com/status/'+data.x:data.oembed;
        const response=await fetch(endpoint,{credentials:'omit',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(8000)});
        if(!response.ok)throw new Error('Cover unavailable');
        const json=await response.json();
        return data.x?this.xMedia(json.tweet||json.status,data.mediaIndex):{cover:this.safeMediaURL(json.thumbnail_url)};
      })().catch(()=>{this.constructor.covers.delete(key);return null;});
      this.constructor.covers.set(key,{time:Date.now(),promise});return promise;
    }
    loadCovers(){
      this.coverObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(!entry.isIntersecting)return;this.coverObserver.unobserve(entry.target);this.loadCover(entry.target);
      }),{rootMargin:'300px'});
      this.querySelectorAll('.ypr__media').forEach(media=>{
        if(media.dataset.mobileUpload!=='true'&&!media.classList.contains('ypr__media--social')&&media.dataset.url&&media.dataset.source!=='upload'&&(!media.querySelector('img')||this.parse(media.dataset.url)?.x))this.coverObserver.observe(media);
      });
    }
    async loadCover(media){
      const raw=media.dataset.url,data=this.parse(raw),epoch=this.mediaEpoch;if(!data)return;
      if(data.native){this.previewFrame(media,data.url);return;}
      const resolved=await this.mediaFor(data),cover=resolved?.cover;
      if(epoch!==this.mediaEpoch)return;
      if(this.isConnected&&media.dataset.url===raw&&data.x&&resolved?.video)this.prepareXVideo(media,resolved,raw);
      if(!this.isConnected||media.dataset.url!==raw||media.querySelector('img')||!cover)return;
      const img=document.createElement('img');img.className='ypr__cover';img.alt='';img.loading='lazy';img.decoding='async';img.referrerPolicy='no-referrer';img.src=cover;
      img.addEventListener('error',()=>img.remove(),{once:true});media.querySelector('.ypr__poster').prepend(img);
    }
    previewFrame(media,url){
      if(media.querySelector('.ypr__cover'))return;
      const video=document.createElement('video');video.className='ypr__cover ypr__cover-video';video.muted=true;video.playsInline=true;video.preload='metadata';video.tabIndex=-1;video.setAttribute('aria-hidden','true');
      video.addEventListener('loadedmetadata',()=>{try{if(video.duration>0.1)video.currentTime=0.1;}catch{}},{once:true});
      video.addEventListener('error',()=>video.remove(),{once:true});video.src=url;media.querySelector('.ypr__poster').prepend(video);
    }
    inlineStatus(target,kind,url){
      const content=this.querySelector('.ypr__status-template').content.cloneNode(true);
      content.querySelector('[data-loading]').hidden=kind!=='loading';
      content.querySelector('[data-unavailable]').hidden=kind!=='error';
      const link=content.querySelector('a');link.hidden=kind!=='error'||!url;if(url)link.href=url;
      target.replaceChildren(content);
    }
    startVideo(media,video,token,original){
      const target=media.querySelector('.ypr__player');
      video.className='ypr__native';video.controls=true;video.playsInline=true;video.autoplay=true;video.preload='metadata';
      const cover=media.querySelector('.ypr__poster img');if(cover)video.poster=cover.currentSrc||cover.src;
      video.addEventListener('error',()=>{if(token===this.playToken)this.inlineStatus(target,'error',original);},{once:true});
      target.replaceChildren(video);target.hidden=false;media.querySelector('.ypr__poster').hidden=true;media.querySelector('.ypr__stop').hidden=false;
      this.requestPlayback(video,media,token,original);
    }
    async requestPlayback(video,media,token,original){
      try{await video.play();}catch(error){
        if(token!==this.playToken||!video.isConnected||error.name==='AbortError')return;
        if(error.name==='NotAllowedError'){
          video.muted=true;
          try{await video.play();return;}catch(retry){if(retry.name==='AbortError')return;}
        }
        if(token===this.playToken)this.inlineStatus(media.querySelector('.ypr__player'),'error',original);
      }
    }
    prepareXVideo(media,resolved,original){
      const existing=this.xPlayers.get(media);if(existing&&existing.url===original&&existing.frame.isConnected)return existing;
      const target=media.querySelector('.ypr__player'),frame=document.createElement('iframe');
      frame.title=media.querySelector('.ypr__poster').getAttribute('aria-label');
      frame.allow='autoplay; fullscreen; picture-in-picture';frame.allowFullscreen=true;frame.referrerPolicy='no-referrer';
      frame.setAttribute('sandbox','allow-scripts allow-same-origin');
      const doc=document.implementation.createHTMLDocument('Video'),meta=doc.createElement('meta');
      meta.name='referrer';meta.content='no-referrer';doc.head.append(meta);
      doc.body.style.cssText='margin:0;background:#000;overflow:hidden';
      const video=doc.createElement('video');video.src=resolved.video;video.controls=true;video.playsInline=true;video.preload='metadata';
      video.style.cssText='display:block;width:100%;height:100vh;object-fit:contain;background:#000';
      const cover=media.querySelector('.ypr__poster img');if(cover||resolved.cover)video.poster=cover?.currentSrc||cover?.src||resolved.cover;
      doc.body.append(video);
      const record={url:original,frame,video:null};record.promise=new Promise(resolve=>record.resolve=resolve);this.xPlayers.set(media,record);
      frame.addEventListener('load',()=>{
        const player=frame.contentDocument?.querySelector('video');record.video=player;record.resolve(player||null);
        if(!player)return;
        player.addEventListener('error',()=>{this.xPlayers.delete(media);if(!target.hidden)this.inlineStatus(target,'error',original);else frame.remove();},{once:true});
      },{once:true});
      frame.srcdoc=doc.documentElement.outerHTML;target.replaceChildren(frame);
      return record;
    }
    stop(){
      this.playToken=(this.playToken||0)+1;
      this.querySelectorAll('.ypr__player').forEach(player=>{
        const media=player.parentElement,prepared=this.xPlayers?.get(media);
        if(media.classList.contains('ypr__media--social'))return;
        player.querySelectorAll('video').forEach(v=>v.pause());
        if(prepared?.frame.parentElement===player){const v=prepared.video;if(v){v.pause();try{v.currentTime=0;}catch{}v.muted=false;}}
        else player.replaceChildren();player.hidden=true;
        media.querySelector('.ypr__poster').hidden=false;media.querySelector('.ypr__stop').hidden=true;
      });
    }
    async play(media){
      this.stop();const token=this.playToken;this.trigger=media.querySelector('.ypr__poster');const target=media.querySelector('.ypr__player');
      if(media.dataset.source==='upload'||media.dataset.mobileUpload==='true'){
        const template=media.querySelector('template');if(!template)return;
        const video=template.content.querySelector('video')?.cloneNode(true);if(video)this.startVideo(media,video,token);return;
      }
      const data=this.parse(media.dataset.url);if(!data)return;
      if(data.external||media.dataset.source==='external'){window.open(data.url,'_blank','noopener,noreferrer');return;}
      if(data.x){
        target.hidden=false;this.trigger.hidden=true;media.querySelector('.ypr__stop').hidden=false;
        const prepared=this.xPlayers.get(media);
        if(prepared?.video&&prepared.url===data.url&&prepared.frame.isConnected){this.requestPlayback(prepared.video,media,token,data.url);return;}
        if(!prepared)this.inlineStatus(target,'loading');
        const resolved=await this.mediaFor(data);
        if(token!==this.playToken||!this.isConnected)return;
        if(!resolved?.video){this.inlineStatus(target,'error',data.url);return;}
        const record=this.prepareXVideo(media,resolved,data.url),video=await record.promise;
        if(token!==this.playToken||!this.isConnected)return;
        if(!video||video.error){this.inlineStatus(target,'error',data.url);return;}
        this.requestPlayback(video,media,token,data.url);return;
      }
      if(data.native){const video=document.createElement('video');video.src=data.url;this.startVideo(media,video,token,data.url);return;}
      target.append(this.frame(data.frame));
      target.hidden=false;this.trigger.hidden=true;media.querySelector('.ypr__stop').hidden=false;
    }
    frame(src){const iframe=document.createElement('iframe');iframe.src=src;iframe.title=this.trigger.getAttribute('aria-label');iframe.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';return iframe;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoniq-support-manual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yoniq-gamepatch-quickstart')) {
    customElements.define('yoniq-gamepatch-quickstart', class extends HTMLElement {
      connectedCallback() {
        if (this.quickstartReady) return;
        const video = this.querySelector('video');
        const button = this.querySelector('.yq-quickstart__play');
        const overlay = this.querySelector('.yq-quickstart__overlay');
        const status = this.querySelector('[role="status"]');
        if (!video || !button) return;
        this.quickstartReady = true;
        const sync = () => {
          const playing = !video.paused && !video.ended;
          button.querySelector('span').textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
          button.querySelector('path').setAttribute('d', playing ? 'M6 5h4v14H6zM14 5h4v14h-4z' : 'm8 5 11 7-11 7Z');
          if (overlay) {
            if (playing && document.activeElement === overlay) button.focus({ preventScroll: true });
            overlay.hidden = playing;
          }
        };
        const togglePlayback = async () => {
          status.textContent = '';
          if (!video.paused && !video.ended) { video.pause(); return; }
          if (video.ended) video.currentTime = 0;
          try { await video.play(); } catch { status.textContent = this.dataset.errorLabel; sync(); }
        };
        button.addEventListener('click', togglePlayback);
        if (overlay) overlay.addEventListener('click', togglePlayback);
        ['play','pause','ended'].forEach(event => video.addEventListener(event,sync));
        video.addEventListener('error', () => { status.textContent = this.dataset.errorLabel; });
        button.hidden = false;
        sync();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
